import React from 'react';
import { Dropdown, Button } from 'react-bootstrap';

import useGlobal from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';
import RetencionesMasivasTicketStatus from '../../enum/RetencionesMasivasTicketStatus';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.tickets.list;
};

const mapActions = (actions) => {
  return actions.modulo.retenciones_masivas.tickets.list;
};

const RetencionesMasivasTicketsFilters = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  let timerId = null;

  const handleOnSelectFilter = (name, filter) => {
    actions.setFilters({
      [name]: filter !== '' ? filter : '',
    });

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      submit();
    }, 1000);
  };

  const submit = () => {
    if (timerId) {
      clearTimeout(timerId);
    }

    actions.paginate({
      pagination: { page: 1 },
    });
  };

  const getStatusLegend = () => {
    const { status } = state.filters;

    let legend = '';

    switch (status) {
      case RetencionesMasivasTicketStatus.pending().getValue().toString():
        legend = 'Pendientes';
        break;
      case RetencionesMasivasTicketStatus.success().getValue().toString():
        legend = 'Timbrados';
        break;
      case RetencionesMasivasTicketStatus.cancelled().getValue().toString():
        legend = 'Cancelados';
        break;
      case RetencionesMasivasTicketStatus.error().getValue().toString():
        legend = 'Errores';
        break;
      case RetencionesMasivasTicketStatus.failed().getValue().toString():
        legend = 'Fallidos';
        break;
      case RetencionesMasivasTicketStatus.queued().getValue().toString():
        legend = 'En proceso';
        break;
      case RetencionesMasivasTicketStatus.duplicate().getValue().toString():
        legend = 'Duplicados';
        break;

      default:
        break;
    }

    return legend;
  };

  return (
    <div className="mb-1 float-left">
      <Dropdown
        onSelect={handleOnSelectFilter.bind(this, 'status')}
        className="float-left mr-1 pb-2"
      >
        <Dropdown.Toggle as={CustomDropdownToggle}>{getStatusLegend() || 'Status'}</Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item eventKey="">Todos</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.pending().getValue()}>Pendientes</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.success().getValue()}>Timbrados</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.cancelled().getValue()}>Cancelados</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.error().getValue()}>Errores</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.failed().getValue()}>Fallidos</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.queued().getValue()}>En proceso</Dropdown.Item>
          <Dropdown.Item eventKey={RetencionesMasivasTicketStatus.duplicate().getValue()}>Duplicados</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Button
        variant="secondary"
        className="text-muted float-xs-right float-sm-right float-md-left"
        onClick={submit}
      >
        Aplicar
      </Button>
    </div>
  );
};

export default RetencionesMasivasTicketsFilters;
